var cov_14niqfkkzd = function () {
  var path = "/Users/spana/SHEIN/shineout/src/DataList/styles/index.js",
      hash = "9defc424699d641de30e2ed4abb5bf5267042eac",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/DataList/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


import genaration from '../../utils/classname';
var listLess = {};
export var listClass = (cov_14niqfkkzd.s[0]++, genaration(listLess, 'list'));